import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getWashBookingByIds,
  getWashBookings,
  updateWashBookingStatus,
} from "../../../services/washBooking.service";
import { WashBooking } from "../../../types/admin/washBookings.types";

const initialState = {
  bookings: [] as WashBooking[],
};

export const getBookings = createAsyncThunk(
  "get/bookings",
  async (
    {
      city,
      fromDate,
      toDate,
      index,
    }: { city?: string; fromDate?: string; toDate?: string; index?: number },
    { rejectWithValue }
  ) => {
    const { data, error } = (await getWashBookings({
      city,
      fromDate,
      toDate,
      index,
    })) as { data: any; error: any };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const getBooking = createAsyncThunk(
  "get/booking",
  async ({ ids }: { ids: string[] }, { rejectWithValue }) => {
    const { data, error } = (await getWashBookingByIds(ids)) as {
      data: { bookings: WashBooking[] };
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const updateBookingStatus = createAsyncThunk(
  "update/booking/status",
  async (
    { _id, status }: { _id: string; status: string },
    { rejectWithValue }
  ) => {
    const { data, error } = (await updateWashBookingStatus(_id, status)) as {
      data: any;
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const bookingSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getBookings.fulfilled, (state, action) => {
      state.bookings = action.payload.bookings;
    });

    builder.addCase(getBooking.fulfilled, (state, action) => {
      action.payload.bookings.forEach((booking) => {
        const existingIndex = state.bookings.findIndex(
          (b) => b._id === booking._id
        );
        if (existingIndex !== -1) {
          state.bookings[existingIndex] = booking;
        } else {
          state.bookings.push(booking);
        }
      });
    });

    builder.addCase(updateBookingStatus.fulfilled, (state, action) => {
      const existingIndex = state.bookings.findIndex(
        (b) => b._id === action.payload.booking._id
      );
      if (existingIndex !== -1) {
        state.bookings[existingIndex] = action.payload.booking;
      }
    });
  },
});

export default bookingSlice.reducer;
